import React, { FC, useState } from 'react';
import { useQueryClient } from 'react-query';
import { TemplateId } from 'api/models';
import { Button } from 'components/atoms/button';
import { Modal } from 'components/atoms/modal';
import { useTranslation } from 'hooks/use-translation';
import { getFormTemplateQueryKey } from 'queries/form-template';
import { RearrangeTree } from './rearrange-tree';

interface Props {
  templateId: number;
  visible: boolean;
  onClose: () => void;
}

export const RearrangeQuestions: FC<Props> = ({
  templateId,
  visible,
  onClose,
}) => {
  const [isDoneLoading, setIsDoneLoading] = useState(false);
  const queryClient = useQueryClient();

  return (
    <Modal
      visible={visible}
      title={useTranslation('form_templates.rearrange_questions')}
      closable={false}
      destroyOnClose
      footer={
        <Button
          type="primary"
          loading={isDoneLoading}
          onClick={async () => {
            setIsDoneLoading(true);
            await queryClient.invalidateQueries(
              getFormTemplateQueryKey(TemplateId(templateId)),
            );
            setIsDoneLoading(false);
            await onClose();
          }}
        >
          {useTranslation('done')}
        </Button>
      }
    >
      <RearrangeTree templateId={templateId} />
    </Modal>
  );
};
